import { jsxs, jsx } from 'react/jsx-runtime';
import { isMobile, Title, CustomLink, styled } from '@teko/ds-desktop';
import { RightOutlined } from '@teko/ds-icon';
import { t } from './i18n.es.js';

const BlockHeader = ({ title, titleColor, link, backgroundColor = 'unset', tracking, }) => {
    return (jsxs(Wrapper, Object.assign({ isMobile: isMobile, backgroundColor: backgroundColor }, { children: [jsx(Title, Object.assign({ color: titleColor ? titleColor : null, className: "title" }, { children: title }), void 0), link && (jsx(CustomLink, Object.assign({}, link, { children: jsxs(SeeAll, Object.assign({ color: link.color }, tracking, { children: [t('Xem tất cả'), jsx(RightOutlined, { color: link.color }, void 0)] }), void 0) }), void 0))] }), void 0));
};
const Wrapper = styled.div(({ isMobile, theme, backgroundColor, }) => `
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${!isMobile
    ? `
          padding-left: ${theme.spacing.s16};
          padding-right: ${theme.spacing.s16};
          `
    : ''}
  height: ${isMobile ? '2.75rem' : '3.5rem'};
  background-color: ${backgroundColor};
`);
const SeeAll = styled.div(({ theme, color }) => `
    cursor: pointer;
    color: ${theme.colors[color] || theme.colors.textSecondary};
`);

export { BlockHeader as B };
